import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles.css';
import { Apply } from './pages/Apply.jsx';
import { Expired } from './pages/Expired.jsx';
import { Completed } from './pages/Completed.jsx';
import { NotFound } from './pages/NotFound.jsx';
import { Centered } from './pages/NotFound.jsx';
import { SignerSign } from './pages/SignerSign.jsx';
import { Admin } from './pages/admin/Admin.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/a/:token" element={<Apply />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/completed/:token" element={<Completed />} />
        <Route path="/sign/:signerToken" element={<SignerSign />} />
        <Route path="/partially-signed/:token" element={
          <Centered title="Thank you — almost done">
            <p>We've emailed and texted the other owner(s) to add their signature. Your application completes once everyone has signed.</p>
          </Centered>
        } />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
